import _classCallCheck from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import 'docsearch.js/dist/npm/styles/main.scss';
var apiKey = process.env.GATSBY_ALGOLIA_API_KEY;
var indexName = process.env.GATSBY_ALGOLIA_INDEX_NAME;

var DocSearch =
/*#__PURE__*/
function (_Component) {
  _inherits(DocSearch, _Component);

  function DocSearch() {
    _classCallCheck(this, DocSearch);

    return _possibleConstructorReturn(this, _getPrototypeOf(DocSearch).apply(this, arguments));
  }

  _createClass(DocSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!apiKey) {
        return;
      } // NOTE: use require to fix gatsby build.
      // https://www.gatsbyjs.org/docs/debugging-html-builds/


      var docSearch = require('docsearch.js');

      docSearch({
        apiKey: apiKey,
        indexName: indexName,
        inputSelector: '#input-search-custom',
        debug: false // Set debug to true if you want to inspect the dropdown

      });
    }
  }, {
    key: "render",
    value: function render() {
      return apiKey ? React.createElement("div", {
        className: "search"
      }, React.createElement("input", {
        type: "text",
        className: "search",
        id: "input-search-custom",
        placeholder: "Search"
      })) : null;
    }
  }]);

  return DocSearch;
}(Component);

export default DocSearch;